import { render, staticRenderFns } from "./main-cart-button.vue?vue&type=template&id=fb7d2a1e&"
import script from "./main-cart-button.vue?vue&type=script&lang=js&"
export * from "./main-cart-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports